module.exports = __webpack_public_path__ + "assets/7081012a393c93c6f390ffcc0aded7c9.png";